import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { FLAGS } from '~/constants/flags'

// Transmit feature key like ACD-1000,... to know which ticket's debug mode flag is being used.
// eslint-disable-next-line no-unused-vars
export const useDebugMode = (featureKey) => {
  return useFeatureIsOn(FLAGS.BS_DEBUG_MODE)
}
